"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockAvatar = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
exports.mockAvatar = 'https://cdn.3d4medical.com/complete_anatomy-userdata/11938/groups/20170713_150903.jpeg';
const membership = {
    avatar: exports.mockAvatar,
    status: bridge_schema_1.MembershipStatus.None,
    identifier: 112,
    isAdmin: false,
    isFounder: true,
    name: 'Mocked Name',
    userIdentifier: 112,
};
exports.default = membership;
